export enum ResponseAction {
    ACCEPT='ACCEPT', REJECT = 'REJECT', CUSTOM = 'CUSTOM'
}
